// socket.js
import { io } from 'socket.io-client'

const socket = io('https://noti.shwekankaung.com', {
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 100
})

socket.on('connect', () => {
    console.log('✅ Connected to WebSocket Server:', socket.id)
})

socket.on('disconnect', () => {
    console.warn('❌ Disconnected from WebSocket Server')
})

export default socket
